import { render, staticRenderFns } from "./TextFieldRecipientsComponent.vue?vue&type=template&id=274690c6&scoped=true"
import script from "./TextFieldRecipientsComponent.vue?vue&type=script&lang=js"
export * from "./TextFieldRecipientsComponent.vue?vue&type=script&lang=js"
import style0 from "./TextFieldRecipientsComponent.vue?vue&type=style&index=0&id=274690c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274690c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274690c6')) {
      api.createRecord('274690c6', component.options)
    } else {
      api.reload('274690c6', component.options)
    }
    module.hot.accept("./TextFieldRecipientsComponent.vue?vue&type=template&id=274690c6&scoped=true", function () {
      api.rerender('274690c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TextFieldRecipientsComponent.vue"
export default component.exports